import { useEffect, useState } from "react";
import { getUserAchievements } from "../services/wisdomServices/userService";
import { getAchievementLevelConfig } from "../utils/helper/achievementsLevel";
import { getSessionItem } from "../utils/helper/session";

export const useUserAchievements = () => {
    const user = getSessionItem("User");
    const [achievements, setAchievements] = useState(null);
    const [loadingAchievements, setLoadingAchievements] = useState(false);
    const [achievementsError, setAchievementsError] = useState(null);

    useEffect(() => {
        let cancelled = false;

        const fetchAchievements = async () => {
        if (!user) {
            setAchievements(null);
            return;
        }

        try {
            setLoadingAchievements(true);
            setAchievementsError(null);

            const response = await getUserAchievements(user.id);
            if (!cancelled) {
            setAchievements(response);
            }
        } catch (error) {
            console.error("Error fetching user achievements:", error); // Debugging line
            if (!cancelled) {
            setAchievementsError(error);
            setAchievements(null);
            }
        } finally {
            if (!cancelled) {
            setLoadingAchievements(false);
            }
        }
        };

        fetchAchievements();

        return () => {
        cancelled = true;
        };
    }, []);

    const levelConfig = getAchievementLevelConfig(achievements?.level);

    return {
        achievements,
        levelConfig,
        loadingAchievements,
        achievementsError,
    };
};